export default __webpack_public_path__ + "static/media/onboardingWelcome.1c58d7db.png";